// import vuex actions and getters
import {mapActions, mapGetters} from "vuex";

// import vue-bootstrap-datetimepicker library
import DatePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

// import font-awesome 5 icons (vue-bootstrap-datetimepicker library requires it)
import "@fortawesome/fontawesome-free/css/fontawesome.css";
import "@fortawesome/fontawesome-free/css/regular.css";
import "@fortawesome/fontawesome-free/css/solid.css";

// import vue components
import VueLoader from "../../../components/layout/Loader";
import VueCustomModal from "../../../components/layout/CustomModal";
import VueTable from "../../../components/layout/Table";
import FormRecord from "../../../components/datasheet/FormRecord";
import RichText from "../../../components/layout/RichText.vue";
import PrivateTooltip from "../../../components/common/PrivateTooltip.vue";
import ObservationDateTimeHTML5 from "../../../components/datasheet/ObservationDateTimeHTML5.vue";
import ObservationDurationTravel from "../../../components/datasheet/ObservationDurationTravel.vue";
import ObservationDurationSetup from "../../../components/datasheet/ObservationDurationSetup.vue";
import DatasheetLocationSelector from "../../../components/datasheet/location"

// use font-awesome 5 icons
$.extend(true, $.fn.datetimepicker.defaults, {
  icons: {
    time: "far fa-clock",
    date: "far fa-calendar",
    up: "fas fa-arrow-up",
    down: "fas fa-arrow-down",
    previous: "fas fa-chevron-left",
    next: "fas fa-chevron-right",
    today: "fas fa-calendar-check",
    clear: "far fa-trash-alt",
    close: "far fa-times-circle"
  }
});



const DATASHEET_DETAILS = {
  records: []
};

const SPECIES_TABLE_COLUMNS = [{
  value: "scientificName", text: "Scientific Name", align: "left", sortable: true
}, {
  value: "canonicalName", text: "Common Name(s)", align: "left", sortable: true
}];

export default {
  components: {
    RichText,
    DatePicker,
    VueLoader,
    ObservationDateTimeHTML5,
    ObservationDurationTravel,
    ObservationDurationSetup,
    DatasheetLocationSelector,
    VueCustomModal,
    VueTable,
    FormRecord,
    PrivateTooltip,
  },

  props: {
    isSubmitButton: {
      type: Boolean, default: false
    }
  },

  provide() {
    return {
      parentValidator: this.$validator
    };
  },

  data() {
    return {
      observer: null,
      location: null,

      // Time state for ObservationDateTime preview
      timeState: {
        entryStartedAt: moment(),
        observedAt: null,
        observationEndedAt: null,
        observationEndMode: 'manual',
        durationUnit: "minutes",
        durationTravel: null,
        durationSetup: null,
        observationEndTimerId: null,
      },

      // organismRecordSelectedSpecies: null,
      selectedOrganismRecordId: null,
      selectedOrganismMapping: [],
      selectedSpecies: [],
      speciesTableColumns: SPECIES_TABLE_COLUMNS,

      // Bootstrap modal data
      bootstrapOrganismSearch: '',
      bootstrapSelectedOrganism: null,
      bootstrapOrganismCurrentPage: 1,
      bootstrapOrganismPerPage: 10,
      bootstrapOrganismFields: [
        { key: 'scientificName', label: 'Scientific Name', sortable: true },
        { key: 'canonicalName', label: 'Common Name(s)', sortable: true },
        { key: 'rank', label: 'Rank', sortable: true },
        { key: 'selected', label: 'Select', class: 'text-center' }
      ],

      customErrorMessage: "",
      datasheetDetails: DATASHEET_DETAILS,
      projectMembers: [],
    };
  },

  computed: {
    ...mapGetters({
      created: "datasheet/form/created",
      isLoading: "datasheet/form/isLoading",
      error: "datasheet/form/error",
      membershipMap: 'user/profile/membershipMap',
      retrievedDatasheet: "datasheet/creator/retrievedDatasheet",
      retrievedDatasheetIsLoading: "datasheet/creator/retrievedDatasheetIsLoading",
      retrievedDatasheetError: "datasheet/creator/retrievedDatasheetError",
      retrievedOrganisms: "datasheet/creator/retrievedOrganisms",
      retrievedOrganismsView: "datasheet/creator/retrievedOrganismsView",
      retrievedOrganismsError: "datasheet/creator/retrievedOrganismsError",
      retrievedOrganismsIsLoading: "datasheet/creator/retrievedOrganismsIsLoading",
      updatedDatasheetRecordDetailsError: "datasheet/creator/updatedDatasheetRecordDetailsError",
      uploadLoadingStatus: "file/observationImages/isUploading",
      userId: 'user/profile/id',
      displayName: 'user/profile/displayName'
    }),
  },

  watch: {
    created(observation) {
      console.log('observation created', this.datasheetDetails.locationAutoAssign)
      if (!observation) {
        return;
      }

      if (this.datasheetDetails.locationAutoAssign && !this.location['@id']) {
        // Pass new location + auto assign parameter to view observation route
        this.$router.push({
          name: "ObservationShow", params: {id: observation.id, isNewAutoAssign: true, addedNewObservation: true}
        });
      } else {
        this.$router.push({
          name: "ObservationShow", params: {id: observation.id, addedNewObservation: true}
        });
      }
    },

    retrievedDatasheet(datasheet) {
      this.datasheetDetails = {
        ...datasheet, records: datasheet.records.map((record) => {
          return {
            ...record, records: record.records.map((subRecord) => {
              return {
                ...subRecord
              }
            })
          }
        })
      };

      if (this.datasheetDetails.records && this.datasheetDetails.records.length > 0) {
        this.datasheetDetails.records.forEach(record => {
          this.setUsefulRecordFields(record);

          if (record.records && record.records.length > 0) {
            record.records.forEach(subRecord => {
              this.setUsefulRecordFields(subRecord);
            });
          }
        });
      }
      this.initializeTimeState(this.datasheetDetails.dateFormat);

    },

  },

  created() {
    this.datasheetId = this.$route.params.id;
    this.observer = {
      text: this.displayName,
      value: this.userId
    };
    this.projectMembers = [this.observer];
    this.retrieveDatasheet(`/datasheets/${this.datasheetId}`);
    this.clearFileUploads();
  },

  mounted() {
    this.toggleBodyId("addId", "custom-vuetify-style");
  },

  destroyed() {
    // Clear the observation end auto-update timer
    if (this.timeState.observationEndTimerId) {
      clearInterval(this.timeState.observationEndTimerId);
      this.timeState.observationEndTimerId = null;
    }
    this.clearFileUploads();
    this.toggleBodyId("removeId", "custom-vuetify-style");
  },

  methods: {
    ...mapActions({
      create: "datasheet/form/create",
      retrieveDatasheet: "datasheet/creator/retrieveDatasheet",
      retrieveOrganisms: "datasheet/creator/retrieveOrganisms",
      clearFileUploads: "file/observationImages/clearUploads",
    }),
    initializeTimeState(dateFormat) {
      const hasEndTime = ['start_end_minutes', 'start_end_seconds'].includes(dateFormat);
      const stampFormat = () => {
        if (['start_end_minutes', 'date_hour_minutes'].includes(dateFormat)) {
          return 'YYYY-MM-DD HH:mm';
        } else if (['start_end_seconds', 'datetime'].includes(dateFormat)) {
          return 'YYYY-MM-DD HH:mm:ss';
        } else if (['date'].includes(dateFormat)) {
          return 'YYYY-MM-DD'; // default to minutes if not specified
        }
      }
      this.timeState.observedAt = moment();
      this.timeState.observationEndedAt = hasEndTime ? moment() : null;
      this.timeState.observationEndMode = hasEndTime ? 'automatic' : 'manual';
      if(hasEndTime) {
        console.log('start end format, starting timer')
        this.timeState.observationEndTimerId = window.setInterval(() => {
        this.timeState.observationEndedAt = moment();
        }, stampFormat().includes('ss') ? 1000 : 15000); // one second or 15 seconds depending on whether the format includes seconds
      }
     },

    onObservationStartUpdated(value) {
      this.timeState.observedAt = value ? moment(value) : null;
    },
    onObservationEndUpdated(value) {
      console.log('manual update of observation end time, stopping auto updates')
      this.timeState.observationEndedAt = value ? moment(value) : null;
    },
    switchObservationEndToManual() {
      if (this.timeState.observationEndMode === 'manual') {
        return;
      }
      this.timeState.observationEndedAt = null;
      this.timeState.observationEndMode = 'manual';
      if (this.timeState.observationEndTimerId) {
        window.clearInterval(this.timeState.observationEndTimerId);
        this.timeState.observationEndTimerId = null;
      }
    },

    toggleDurationUnit() {
      this.timeState.durationUnit = this.timeState.durationUnit === "minutes" ? "hours" : "minutes";
    },

    openOrganismsModal(id) {
      this.selectedOrganismRecordId = id;
      this.$modal.show("add-organism");
    },

    // Bootstrap modal methods
    openOrganismsModalBootstrap(id) {
      this.selectedOrganismRecordId = id;
      this.bootstrapSelectedOrganism = null;
      this.bootstrapOrganismSearch = '';
      this.bootstrapOrganismCurrentPage = 1;
      // Fetch organisms data when modal opens with proper pagination object
      this.retrieveOrganisms({
        page: 1,
        sortBy: null,
        descending: false,
        search: ''
      });
      this.$bvModal.show("add-organism-bootstrap");
    },

    closeBootstrapOrganismModal() {
      this.$bvModal.hide("add-organism-bootstrap");
    },

    onBootstrapModalHidden() {
      // Reset state when modal is hidden
      this.bootstrapSelectedOrganism = null;
      this.bootstrapOrganismSearch = '';
      this.bootstrapOrganismCurrentPage = 1;
    },

    onBootstrapOrganismRowSelected(items) {
      this.bootstrapSelectedOrganism = items.length > 0 ? items[0] : null;
    },

    onBootstrapOrganismRadioChange(item) {
      this.bootstrapSelectedOrganism = item;
    },

    onSearchOrganismBootstrap() {
      // Trigger organism search using existing Vuex action with proper pagination object
      this.retrieveOrganisms({
        page: 1,
        sortBy: null,
        descending: false,
        search: this.bootstrapOrganismSearch.trim()
      });
      this.bootstrapOrganismCurrentPage = 1; // Reset to first page on search
    },

    onSubmitSelectedSpeciesBootstrap() {
      if (!this.bootstrapSelectedOrganism) return;

      let exists = this.selectedOrganismMapping.filter(x => {
        return x.recId !== this.selectedOrganismRecordId
      })
      this.selectedOrganismMapping = [...exists, {
        recId: this.selectedOrganismRecordId,
        species: this.bootstrapSelectedOrganism
      }]
      this.selectedOrganismRecordId = null;

      // hide the bootstrap modal
      this.$bvModal.hide("add-organism-bootstrap");
    },

    onSubmitSelectedSpecies() {
      let exists = this.selectedOrganismMapping.filter(x => {
        return x.recId !== this.selectedOrganismRecordId
      })
      this.selectedOrganismMapping = [...exists, {
        recId: this.selectedOrganismRecordId,
        species: this.selectedSpecies[0]
      }]
      this.selectedOrganismRecordId = null;

      // hide the modal
      this.$modal.hide("add-organism");
    },

    selectedOrganismName(recId) {
      let organism = this.selectedOrganismMapping.find(x => {
        return x.recId === recId
      })
      if (organism) {
        let species = organism.species
        return species.customName ? species.customName :
          species.canonicalName && species.scientificName ? species.canonicalName + " (" + species.scientificName + ")" :
            species.canonicalName ? species.canonicalName :
              species.scientificName ? species.scientificName :
                ''
      } else {
        return ''
      }
    },

    fixedOrganismDropdownValues(organismRecord) {
      return organismRecord.map(org => {
        return {
          value: org,
          text: org.customName ? org.customName : org.canonicalName && org.scientificName ? org.canonicalName + " (" + org.scientificName + ")" : ""
        }
      })
    },

    setUsefulRecordFields(record) {
      record.marker = record["@id"];
      record.optionValue = null;
      record.optionValues = [];
      record.requiredField = false;
      record.validatorRules = "";
      record.files = [];
      record.initialDefaultValue = record.defaultValue ? record.defaultValue : null;
      record.selectedSpecies = record.organisms && record.organisms.length === 1 ? record.organisms[0] : null;

      // Set the validation rules for the record
      if (record && record.validators && record.validators.length > 0) {
        record.validators.forEach(validator => {
          if (validator.validatorType && validator.value) {
            if (record.validatorRules && record.validatorRules !== "" && validator.validatorType !== "isRequired") {
              record.validatorRules += "|";
            }

            if (validator.validatorType === "isRequired" && validator.value) {
              record.validatorRules = "required|" + record.validatorRules;
              record.requiredField = true;
            } else if (validator.validatorType === "isInteger" && validator.value) {
              record.validatorRules = "integer|" + record.validatorRules;
            } else {
              // Vee-Validate needs min_value and max_value for numeric field validation
              if (record.recordType === "number") {
                record.validatorRules += validator.validatorType + "_value:" + validator.value;
              } else if (record.recordType === "image") {
                record.validatorRules += validator.validatorType + "_array:" + validator.value;
              } else {
                record.validatorRules += validator.validatorType + ":" + validator.value;
              }
            }
          }
        });
      }

      // For number fields, set vee-validate as decimal
      if (record.validatorRules === "" && record.recordType === "number") {
        record.validatorRules = "decimal"
      }

      // Default option value, if set, is assigned for radio and dropdown
      if (record && record.optionsSet && record.optionsSet.optionsValues) {
        // Use the newly added default value from OptionsSet instead of searching through Options Values for the default values
        // const defaultSelectedObject = this.$_.find(record.optionsSet.optionsValues, option => {
        //   return option.isDefault
        // })

        const defaultSelectedObject = record.optionsSet.defaultOptionValue;
        if (defaultSelectedObject) {
          if (record.recordType === "radio") {
            if (defaultSelectedObject && defaultSelectedObject["@id"]) {
              record.optionValue = defaultSelectedObject["@id"];
            }
          } else if (record.recordType === "dropdown") {
            record.optionValue = defaultSelectedObject;
          }
        }
      }
    },

    async submit() {
      // On button pressed run validation
      this.customErrorMessage = "";
      // validate everything, including the date/time fields in the header and footer and the location selector, before allowing submission
      const headerTimeValid = this.$refs.observationDateTimeHeader
        ? await this.$refs.observationDateTimeHeader.validate()
        : true;
      const footerTimeValid = this.$refs.observationDateTimeFooter
        ? await this.$refs.observationDateTimeFooter.validate()
        : true;
      const locationValid = await this.$refs.location.validate();
      const formValid = await this.$validator.validateAll();
      // Show the first error message encountered and scroll to it
      if (!headerTimeValid || !footerTimeValid) {
        this.customErrorMessage = "Please check the date/time fields for errors in red";
        this.$nextTick(() => {
          this.$refs.customErrorMessage.$el.scrollIntoView({ behavior: "smooth", block: "center" });
        });
        return;
      }
      if (!locationValid) {
        this.customErrorMessage = "Location is invalid";
        // scroll to location ReferenceError
        this.$refs.location.$el.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
      if (!formValid) {
        this.customErrorMessage = "Please check the form for errors in red";
        this.$nextTick(() => {
          this.$refs.customErrorMessage.$el.scrollIntoView({ behavior: "smooth", block: "center" });
        });
        return;
      }
      this.onCreateObservation();
    },

    onCreateObservation() {
      // Method to parse and create the new observation for submission
      const observedAtMoment = this.timeState.observedAt
        ? (moment.isMoment(this.timeState.observedAt)
          ? this.timeState.observedAt
          : moment(this.timeState.observedAt))
        : null;

      const supportsObservationEnd = ["start_end_minutes", "start_end_seconds"].includes(
        this.datasheetDetails.dateFormat
      );

      const observation = {
        datasheet: this.datasheetDetails["@id"],
        observedAt: observedAtMoment && observedAtMoment.isValid()
          ? observedAtMoment.format("YYYY-MM-DDTHH:mm:ss")
          : null,
        entryStartedAt: this.timeState.entryStartedAt.toISOString(true),
        entryEndedAt: moment().toISOString(true),
        ...(supportsObservationEnd
          ? {
              observationEndedAt: this.timeState.observationEndedAt
                ? this.timeState.observationEndedAt.format("YYYY-MM-DDTHH:mm:ss")
                : null,
            }
          : {}),
        durationTravel: this.timeState.durationTravel ? this.timeState.durationTravel : null,
        durationSetup: this.timeState.durationSetup ? this.timeState.durationSetup : null,
        lngLat: (this.location && this.location.lngLat) ? this.location.lngLat : null,
        location: this.location,
        records: []
      };

      if(observation.lngLat === null || observation.location === null) {
        this.customErrorMessage = "Please select a location for the observation";
        this.$refs.location.$el.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }

      const datasheetRecords = this.datasheetDetails.records;

      // Each datasheet record is processed
      datasheetRecords.forEach(record => {

        if (record.recordType === 'description') {
          return
        }

        let selectedOrganism = null;
        const subRecords = [];

        // Handle organism records
        if (record.organisms) {
          if (record.organisms.length > 0 || record.allowAnyOrganism) {
            if (record.selectedSpecies) {
              this.customErrorMessage = "";

              selectedOrganism = {
                organism: "/organisms/" + record.selectedSpecies.organismId,
                customName: record.selectedSpecies.customName
              };
            } else if (this.selectedOrganismMapping.length > 0) {
              this.customErrorMessage = "";
              let organism = this.selectedOrganismMapping.find(x => {
                return x.recId === record.id
              })
              console.log('organism', organism.species)
              selectedOrganism = {
                organism: organism.species["@id"], customName: null
              };
            } else {
              // this.customErrorMessage =
              //   "Each organism list must have an organism selected";
            }
          }

          // Child organism records are handled here
          if (record.records.length > 0) {
            record.records.forEach(childRec => {
              if (childRec.recordType === 'description') {
                return
              }
              let fieldValue = null;
              if (childRec.recordType === "datetime" && childRec.defaultValue) {
                fieldValue = moment(childRec.defaultValue, "YYYY/MM/DD h:mm:ss A").format("YYYY-MM-DDTHH:mm:ss");
              } else if (childRec.recordType !== "datetime") {
                fieldValue = childRec.defaultValue;
              }


              const subRecord = {
                datasheetRecord: childRec["@id"],
                description: childRec.description,
                label: childRec.label,
                orderNumber: childRec.orderNumber,
                recordType: childRec.recordType,
                // A 0 is a valid answer, so only a missing or blank entry becomes null
                value: fieldValue === undefined || fieldValue === null || fieldValue === "" ? null : fieldValue,
              };

              if (['multiple_choice'].includes(childRec.recordType) && (childRec.optionValue && childRec.optionValue.length > 0)) {
                subRecord.multiSelectOptionValues = childRec.optionValue
              } else if (['dropdown', 'radio'].includes(childRec.recordType)) {
                subRecord.optionValue = childRec.optionValue
              } else if (['image'].includes(childRec.recordType)) {
                subRecord.files = childRec.files
              }

              // Final validation check before pushing the observation sub record to the array
              if (!this.isRecordEmpty(subRecord)) {
                subRecords.push(subRecord);
              }
            });
          }
        }

        let fieldValue = null;
        if (record.recordType === "datetime" && record.defaultValue) {
          fieldValue = moment(record.defaultValue, "YYYY/MM/DD h:mm:ss A").format("YYYY-MM-DDTHH:mm:ss");
        } else if (record.recordType !== "datetime") {
          fieldValue = record.defaultValue;
        }


        const observationRecord = {
          datasheetRecord: record["@id"],
          description: record.description,
          label: record.label,
          orderNumber: record.orderNumber,
          recordType: record.recordType,
          records: subRecords,
          // A 0 is a valid answer, so only a missing or blank entry becomes null
          value: fieldValue === undefined || fieldValue === null || fieldValue === "" ? null : fieldValue,
        };

        if (['multiple_choice'].includes(record.recordType) && (record.optionValue && record.optionValue.length > 0)) {
          observationRecord.multiSelectOptionValues = record.optionValue
        } else if (['dropdown', 'radio'].includes(record.recordType)) {
          observationRecord.optionValue = record.optionValue
        } else if (['image'].includes(record.recordType)) {
          observationRecord.files = record.files
        }

        if (record.recordType === "organism") {
          if (selectedOrganism) {
            observationRecord.organism = selectedOrganism;
          } else if (observationRecord.records.length > 0) {
            this.customErrorMessage = "Please select an organism. You have an organism that contains records, but you did not identify which organism it is for.";
          }
        }

        // Final validation check before pushing the observation to the array
        if (!this.isRecordEmpty(observationRecord)) {
          observation.records.push(observationRecord);
        }
      });
      if(observation.records.length === 0) {
        this.customErrorMessage = "At least one record / question must be responded to.";
        this.$refs.location.$el.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }

      if (!this.customErrorMessage) {
        this.create(observation);
      }
    },

    isRecordEmpty(record) {
      if (['dropdown', 'radio'].includes(record.recordType)) {
        if (record.optionValue === null) {
          return true
        }
      } else if (['multiple_choice'].includes(record.recordType)) {
        if (!record.hasOwnProperty('multiSelectOptionValues')) {
          return true
        }
      } else if (['number', 'text', 'textarea', 'datetime'].includes(record.recordType)) {
        if (record.value === null) {
          return true
        }
      } else if (['image'].includes(record.recordType)) {
        if (record.files === null || record.files.length === 0) {
          return true
        }
      } else if (['organism'].includes(record.recordType)) {
        if (!record.hasOwnProperty('organism')) {
          return true
        } else {
          // Default organism present
          if (record.records.length === 0) {
            return true
          }
        }
      }
      return false
    },

    toggleBodyId(addRemoveId, idName) {
      const el = document.body;

      if (addRemoveId === "addId") {
        el.setAttribute("id", idName);
      } else {
        el.removeAttribute("id");
      }
    },

    onDuplicateDatasheetRecord(record) {
      const recordToDuplicate = {
        "@id": record["@id"],
        marker: moment()
          .valueOf()
          .toString(),
        files: [],
        allowReplica: false,
        optionValue: record.optionValue,
        id: record.id,
        initialDefaultValue: record.initialDefaultValue,
        isReady: record.isReady,
        orderNumber: record.orderNumber,
        parentRecord: record.parentRecord,
        recordType: record.recordType,
        requiredField: record.requiredField,
        selectedSpecies: record.selectedSpecies,
        appearanceOptions: record.appearanceOptions,
        defaultValue: record.defaultValue,
        optionsSet: record.optionsSet,
        updatedAt: record.updatedAt,
        validators: []
      };

      if (record.recordType === "organism") {
        recordToDuplicate.allowAnyOrganism = record.allowAnyOrganism;
        recordToDuplicate.organisms = [];
        recordToDuplicate.records = [];

        record.organisms.forEach(organism => {
          recordToDuplicate.organisms.push({
            "@id": organism["@id"],
            canonicalName: organism.canonicalName,
            customName: organism.customName,
            organismId: organism.organismId,
            rank: organism.rank,
            scientificName: organism.scientificName
          });
        });

        record.records.forEach(r => {
          const rToDuplicate = {
            "@id": r["@id"],
            marker: moment()
              .valueOf()
              .toString(),
            files: [],
            allowReplica: false,
            optionValue: r.optionValue,
            id: r.id,
            initialDefaultValue: r.initialDefaultValue,
            isReady: r.isReady,
            orderNumber: r.orderNumber,
            parentRecord: r.parentRecord,
            recordType: r.recordType,
            requiredField: r.requiredField,
            selectedSpecies: r.selectedSpecies,
            appearanceOptions: r.appearanceOptions,
            defaultValue: r.defaultValue,
            optionsSet: r.optionsSet,
            validators: []
          };

          rToDuplicate.label = r.label;
          rToDuplicate.description = r.description;

          recordToDuplicate.records.push(rToDuplicate);
        });
      } else {
        recordToDuplicate.label = record.label;
        recordToDuplicate.description = record.description;
      }

      this.datasheetDetails.records.splice(record.orderNumber, 0, recordToDuplicate);
      this.adjustRecordsOrderNumber(this.datasheetDetails.records);
    },

    adjustRecordsOrderNumber(records) {
      let recordOrderNumber = 1;

      records.forEach(record => {
        if (record.orderNumber) {
          record.orderNumber = recordOrderNumber++;
        }

        if (record.records && record.records.length > 0) {
          let subrecordOrderNumber = 1;

          record.records.forEach(subrecord => {
            subrecord.orderNumber = subrecordOrderNumber++;
          });
        }
      });
    },
  }
};
